import mutations from "@/store/mutations/maskMutation";
import getters from "@/store/getters/maskGetter";
import actions from "@/store/actions/maskAction";
/**
 *  mask
 */

export default {
  state: {
    toastData: {},
    showLoaing: false
  },
  mutations: mutations,
  getters: getters,
  actions: actions
};